/**********************
 * REDUX ACTION TYPES *
 **********************/
const referencesNamespace = 'references';
export const UPDATE_FILTER = `${referencesNamespace}/UPDATE_FILTER`;
export const UPDATE_DUTYSTATE_REFERENCES = `${referencesNamespace}/UPDATE_DUTYSTATE_REFERENCES`;
export const UPDATE_RANK_REFERENCES = `${referencesNamespace}/UPDATE_RANK_REFERENCES`;
export const DELETE_CHAPTER_ACTION = `${referencesNamespace}/DELETE_CHAPTER_ACTION`;
